import { CheckCircle2, Star } from "lucide-react";

const ITEMS = [
  "Ages accepted: 3 – 12 years old",
  "Camp times vary by location — check the weekly calendar for each date's hours.",
  "Drop-off and pick-up times vary by location.",
  "Parents must provide lunch, snacks, and a water bottle.",
  "Comfortable clothes and closed-toe shoes recommended.",
  "Advance registration is required.",
  "Limited spots available.",
  "Payment required to confirm enrollment, if applicable.",
];

export const ParentInfo = () => (
  <div data-testid="parent-info-section" id="parent-info" className="bg-teal-400 rounded-[2rem] p-7 sm:p-9 shadow-pop-teal h-full relative overflow-hidden">
    <Star className="absolute top-5 right-6 w-10 h-10 text-yellow-300 animate-wiggle" fill="#FFD93D" />
    <h3 className="font-display font-bold text-3xl text-white mb-6">What Parents Need to Know</h3>
    <ul className="space-y-4">
      {ITEMS.map((t) => (
        <li key={t} className="flex items-start gap-3 text-white font-semibold text-base">
          <CheckCircle2 className="w-6 h-6 shrink-0 text-emerald-900" />
          <span>{t}</span>
        </li>
      ))}
    </ul>
  </div>
);
